module.exports = __webpack_public_path__ + "img/play.a2c838c6.svg";